import React from 'react';
import {
  Box,
  Button,
  Grid,
  HStack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
} from '@chakra-ui/react';
import { FiChevronLeft, FiCheck, FiInfo } from 'react-icons/fi';
import { SaktiBkmSimulationData } from '../types';

interface SaktiBkmSimulationProps {
  data: SaktiBkmSimulationData | null;
  loading: boolean;
  onBack: () => void;
}

const SaktiBkmSimulation: React.FC<SaktiBkmSimulationProps> = ({
  data,
  loading,
  onBack,
}) => {
  if (!data && !loading) return null;

  return (
    <VStack align="stretch" spacing={4}>
      <HStack justify="space-between">
        <Button leftIcon={<FiChevronLeft />} variant="ghost" onClick={onBack}>Kembali ke List</Button>
        <Button leftIcon={<FiCheck />} colorScheme="green">Apply ke BKM</Button>
      </HStack>

      <Grid templateColumns={{ base: '1fr', lg: '3fr 1fr' }} gap={4}>
        <Box bg="white" p={4} borderRadius="xl" borderWidth="1px">
          <Text fontWeight="bold" mb={2}>Konteks Simulasi</Text>
          <Grid templateColumns="repeat(3, 1fr)" gap={4}>
            <Box>
              <Text fontSize="xs" color="gray.500">Divisi</Text>
              <Text fontWeight="semibold">{data?.division_name || '-'}</Text>
            </Box>
            <Box>
              <Text fontSize="xs" color="gray.500">Tanggal</Text>
              <Text fontWeight="semibold">{data?.date || '-'}</Text>
            </Box>
            <Box>
              <Text fontSize="xs" color="gray.500">Total HA</Text>
              <Text fontWeight="semibold">{data?.total_ha.toFixed(2) || '0'} ha</Text>
            </Box>
          </Grid>
        </Box>

        <Box bg="green.50" p={4} borderRadius="xl" borderWidth="1px" borderColor="green.200">
          <HStack mb={2} color="green.700"><FiInfo /><Text fontWeight="bold" fontSize="sm">Ringkasan</Text></HStack>
          <VStack align="stretch" spacing={1}>
            <HStack justify="space-between"><Text fontSize="xs">Total Hanca</Text><Text fontWeight="bold">{data?.total_hancas || 0}</Text></HStack>
            <HStack justify="space-between"><Text fontSize="xs">Pemanen</Text><Text fontWeight="bold">{data?.harvesters.length || 0}</Text></HStack>
          </VStack>
        </Box>
      </Grid>

      <Box bg="white" borderRadius="xl" overflow="hidden" borderWidth="1px">
        <Table variant="simple" size="sm">
          <Thead bg="gray.50">
            <Tr>
              <Th>Pemanen</Th>
              <Th isNumeric>Jumlah Hanca</Th>
              <Th isNumeric>Proporsi (%)</Th>
              <Th isNumeric>Luas Alokasi (ha)</Th>
            </Tr>
          </Thead>
          <Tbody>
            {data?.harvesters.map((h) => (
              <Tr key={h.harvester_id}>
                <Td><Text fontWeight="bold">{h.harvester_name}</Text><Text fontSize="xs" color="gray.500">{h.harvester_nip}</Text></Td>
                <Td isNumeric>{h.hanca_count}</Td>
                <Td isNumeric>{((h.hanca_count / data.total_hancas) * 100).toFixed(2)}%</Td>
                <Td isNumeric><strong>{h.proportion_ha.toFixed(3)}</strong></Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </VStack>
  );
};

export default SaktiBkmSimulation;
